<template>
    <div>
        <!-- 视频 -->
        <div style="width: 100%;height: 210px">
            <video class="videoSty" @pause="onPause" @play="onPlay" :src='videoPath' controls poster autoplay></video>
        </div>
        <div>
            <!-- tab -->
            <div class="item-tab">
                <div :class="{ 'courseTab': true, 'selected': activeTitle === 1 }" @click="selectTitle(1)">
                    <span>目录</span>
                    <img class="downsty" v-if="activeTitle === 1" :src="require('@/assets/studyCentre/downLine.png')">
                </div>
                <div style="margin-left:20px ;" :class="{ 'courseTab': true, 'selected': activeTitle === 2 }"
                    @click="selectTitle(2)">
                    <span>简介</span>
                    <img class="downsty" v-if="activeTitle === 2" :src="require('@/assets/studyCentre/downLine.png')">
                </div>
                <div style="margin-left:20px ;" :class="{ 'courseTab': true, 'selected': activeTitle === 3 }"
                    @click="selectTitle(3)">
                    <span>专题练习</span>
                    <img class="downsty" v-if="activeTitle === 3" :src="require('@/assets/studyCentre/downLine.png')">
                </div>
            </div>
            <!-- 目录 -->
            <div v-if="activeTitle === 1" class="item-catalogue">
                <div class="item-padding">
                    <div class="catalogue">{{ lessonDetail.webLesTitle }}</div>
                    <div class="catalogueNum">{{ lessonDetail.learnUsers }} 学习</div>
                </div>
                <div v-for="(item, index) in chapterDetail" :key="index" class="item-padding"
                    @click="lookVideoTime(item)">
                    <div class="listSty" :style="{ color: item.chooseType ? 'red' : '' }">
                        {{ item.webChpTitle }}
                    </div>
                </div>
            </div>
            <!-- 简介 -->
            <div class="synopsis" v-if="activeTitle === 2">
                {{ lessonDetail.webLesDesc }}
            </div>
            <div v-if="activeTitle === 3">
                <!-- <van-list ref="winPrize" v-if="winPrizeList.length > 0" v-model:loading="winPrizeloading"
                    :immediate-check="false" :finished="winPrizefinished" finished-text="没有更多了" @load="winPrizeLoad"
                    :offset="500" class="item-list"> -->
                <van-cell @click="goSeriesDetail(item)" v-for="(item, index) in exerciseDetail" :key="index"
                    class="list-item">
                    <el-image :src="item.url" fit="cover" class="winPrizeimg">
                        <img class="winPrizeimg" style="object-fit: cover"
                            :src="require('@/assets/stormPassAnswer/ranking.png')" slot="error" />
                    </el-image>
                    <div class="list-title">
                        <div>
                            <p class="name">{{ item.webBreakthroughTitle }}</p>
                        </div>
                    </div>
                </van-cell>
                <div v-if="exerciseDetail.length == 0" class="item-none">
                    <img class="default" :src="require('@/assets/studyCentre/none.png')" alt="" />
                </div>
                <!-- </van-list> -->
            </div>

        </div>
    </div>
</template>

<script>
import { filePerviewPath } from "@/api/globalApi.js";
import {
    getLessonDetail,
    postObjectRecord,
    postExerciseRecord
} from "@/api/studyCentre";
export default {
    data() {
        return {
            lessonDetail: {},
            chapterDetail: [],
            exerciseDetail: [],
            videoPath: '',
            activeTitle: 1, // 默认选中推荐课程
            winPrizeList: [
                {
                    webUserName: "sdsdsd",
                    createTime: "2015.2.2",
                    actPriName: 'sdsd'
                }
            ],
            winPrizeloading: false,
            winPrizefinished: false,
            startTime: null, // 视频开始播放时间
            endTime: null, // 视频暂停播放时间
            totalTime: 0,// 视频总播放时间（秒）
            fileObjId: '',
            webChpId: '',
            webLesId: '',
            pauseState: false,//是否为暂停状态：暂停在视频暂停方法内计算观看时间，不暂停在切换或者直接退出计算观看时间
        }
    },
    mounted() {
    document.title = "系列课程";

  },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        this.id = urlParams.get('id');
        this.getDetail(this.id)
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    },
    computed: {
    },
    methods: {
        //跳转 专题练习 postExerciseRecord
        goSeriesDetail(val) {
            let webTenId = localStorage.getItem('webTenId');
            let dataInfo = {
                webBtId: val.webBtId,
                webExerId: val.webExerId,
                webLesId: this.id
            }
            postExerciseRecord(dataInfo).then(({ data }) => {
                if (data.code == 200) {
                    window.location.href = '/ayAnswer?id=' + val.webBtId + '&webTenId=' + webTenId + '&type=' + '2' + '&inside=' + true;
                }
            });
        },
        //时间停止计算秒数
        getTimeS() {
            if (!this.startTime) {
                this.startTime = new Date();
            }
            this.endTime = new Date();
            let timeDifference = this.endTime - this.startTime;
            if (!isNaN(timeDifference)) {
                // 计算并将秒数转换为整数
                let secondsElapsed = Math.floor(timeDifference / 1000);
                // 使用 Number.isInteger() 来确保 secondsElapsed 是一个整数
                if (Number.isInteger(secondsElapsed)) {
                    // 将 this.totalTime 转换为数值类型并累加 secondsElapsed
                    this.totalTime = Number(this.totalTime) + secondsElapsed;
                    this.postLookTime(this.totalTime);
                    this.totalTime = 0;
                } else {
                }
            } else {
            }
        },
        onPlay(event) {
            this.startTime = new Date(); // 记录开始时间

        },
        onPause(event) {
            this.pauseState = true; //暂停状态
            console.log("暂停了")
            this.getTimeS()
        },

        postLookTime(e) {
            let data = {
                fileObjId: this.fileObjId,
                webChpId: this.webChpId,
                webLesId: this.webLesId,
                webUserDuration: e,
            }
            postObjectRecord(data).then(({ data }) => {
                if (data.code == 200) {

                }
            });
        },
        beforeUnloadHandler(event) {
            this.getTimeS()
            // this.postLookTime(this.totalTime);
        },
        //观看 切换 
        lookVideoTime(item) {
            // 没有暂停，直接切换
            if (!this.pauseState) {
                this.getTimeS()
            }
            this.chapterDetail.forEach((chapterItem) => {
                // 将点击的项目的 chooseType 设置为 true，其他项目的 chooseType 设置为 false
                chapterItem.chooseType = (chapterItem === item);
            });
            this.pauseState = false;
            // this.postLookTime(this.totalTime);
            this.videoPath = item.url
            this.endTime = ''
            this.startTime = ''
            this.totalTime = ''
            this.fileObjId = item.fileObjId
            this.webChpId = item.webChpId
            this.webLesId = item.webLesId
        },
        //详情
        getDetail(id) {
            getLessonDetail({ webLesId: id }).then(({ data }) => {
                if (data.code == 200) {
                    this.lessonDetail = data.data
                    this.chapterDetail = data.data.webLessonChapterEntities
                    this.chapterDetail.forEach((ele) => {
                        let obj = {
                            fileObjId: ele.fileObjId,
                            downType: "resource",
                        };
                        ele.url = filePerviewPath(obj);
                    });
                    this.videoPath = this.chapterDetail[0].url
                    this.fileObjId = this.chapterDetail[0].fileObjId
                    this.webChpId = this.chapterDetail[0].webChpId
                    this.webLesId = this.chapterDetail[0].webLesId
                    this.chapterDetail[0].chooseType = true


                    this.exerciseDetail = data.data.webLessonExerciseEntities
                    this.exerciseDetail.forEach((ele) => {
                        let obj = {
                            fileObjId: ele.webCovImg,
                            downType: "cover",
                        };
                        ele.url = filePerviewPath(obj);
                    });

                }
            });
        },
        selectTitle(v) {
            this.activeTitle = v;
        },
        winPrizeLoad() {
            console.log("dy");
            // 异步更新数据
            this.winnerNum++;
            // 加载状态结束
            this.winPrizeloading = false;
        },

    }
}
</script>

<style scoped>
.item-tab {
    display: flex;
    align-items: end;
    justify-content: space-around;
    margin: 24px 0;
}

.courseTab {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    height: 28px;
    width: 100px;
}

.courseTab.selected {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    height: 30px;
}

.downsty {
    width: 12px;
    height: 4px;
    margin-top: 5px;
}

.synopsis {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #9c9a9a;
    margin: 0 16px;
}

.item-catalogue {
    padding-bottom: 30px;
}

.item-padding {
    padding: 0 17px;
    border-bottom: #F3F3F3 solid 1px;

}

.catalogue {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
}

.catalogueNum {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin: 9px 0;
}

.listSty {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    padding: 17px 0;
}

.winPrizeimg {
    border-radius: 4px;
    width: 100%;
    height: 190px;
    position: relative;
}

.list-item {
    padding: 6px 16px;
}

.list-title {
    position: absolute;
    bottom: 16px;
    left: 16px;
}

.name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
}

.videoSty {
    width: 100%;
    height: 100%;
}

.item-none {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.default {
    width: 160px;
    height: 185px;
}
</style>